<div class="de-toolbar">
  <ng-container *ngIf="diagramJson">
    <q9-toolbar #toolbar>
      <div q9-left-content>
        <div class="tags-container">
          <q9-tag
            [color]="diagramTagColor()"
            [matTooltip]="'TOOLBAR.CATEGORY_NAME' | translate"
            matTooltipPosition="below">
            {{ tagName() | translate }}
          </q9-tag>

          <q9-tag
            *ngIf="currVersion$ | async as versionName"
            [color]="diagramState | getVersionTagColor"
            [matTooltip]="'TOOLBAR.VERSION_NAME' | translate"
            matTooltipPosition="below">
            {{ versionName | decodeHtml }}
          </q9-tag>
        </div>

        <button
          class="elements-logo-button"
          mat-button
          [matTooltip]="'TOOLBAR.OPEN_DASHBOARD' | translate"
          matTooltipPosition="below"
          (click)="navigateToMapList()">
          <mat-icon svgIcon="elements_logo-icon"></mat-icon>
          App
        </button>

        <div class="dash"></div>

        <div class="main-bar__info-section">
          <div class="main-bar__diagram-main-data">
            <div class="main-bar__diagram-name">
              {{ diagramJson.name | decodeHtml }}
            </div>
            <div *ngIf="!isPending; else pendingBlock" class="main-bar__map-info">
              {{ diagramNameSubRow | decodeHtml }}
            </div>
            <ng-template #pendingBlock>
              <div class="pending-text">
                Level
                <a [href]="diagramVersionsPublishing" class="pending-word">
                  {{ pendingText }}
                </a>
                Level {{ diagramJson.name | decodeHtml }}
              </div>
            </ng-template>
          </div>

          <app-diagram-details
            [diagramData]="diagramJson"
            [generationInProgress]="
              generationProgressService.dvGenerationInProgress$ | async
            "></app-diagram-details>

          <button
            mat-mini-fab
            *ngIf="isArchitecture()"
            q9Track="TOOLBAR.TOGGLE_HEADER"
            matTooltip="{{ 'EDITOR.TOGGLE_PIN_HEADER' | translate }}"
            matTooltipPosition="below"
            [ngClass]="{enabled: headerSvc.isPinned}"
            (click)="headerSvc.togglePin()">
            H
          </button>
        </div>

        <div class="dash"></div>

        <div class="actions-container">
          <app-diagram-navigation></app-diagram-navigation>

          <div class="search-container">
            <q9-icon-button
              [icon]="'search-icon'"
              [matTooltip]="'TOOLBAR.SEARCH_DIAGRAM' | translate"
              matTooltipPosition="below"
              (click)="openSearch()"></q9-icon-button>
            <app-search-diagram *ngIf="showSearch" class="search-input"></app-search-diagram>
          </div>

          <q9-icon-button
            [icon]="'tree-icon'"
            matTooltipPosition="below"
            [matTooltip]="'TOOLBAR.OPEN_MAP' | translate"
            [disabled]="!(diagramJsonSvc.isPro$ | async)"
            (click)="toggleMapTree()"></q9-icon-button>
        </div>
      </div>
    </q9-toolbar>

    <q9-toolbar
      *ngIf="
        diagramState === DIAGRAM_VERSION_STATES_ENUM.DRAFT &&
        toolbarState.canEditDiagram &&
        !(trainingMode$ | async) &&
        !(authorisationMode$ | async)
      ">
      <div q9-left-content>
        <div class="actions-container">
          <q9-icon-button
            *ngIf="toolbarState.editMode"
            [icon]="'undo-icon'"
            [disabled]="!undoSvc.undoQue.length"
            [matTooltip]="'TOOLBAR.UNDO' | translate"
            matTooltipPosition="below"
            [matTooltipDisabled]="!undoSvc.undoQue.length"
            (click)="undoSvc.undo()"></q9-icon-button>
          <q9-icon-button
            *ngIf="toolbarState.editMode"
            [icon]="'redo-icon'"
            [matTooltip]="'TOOLBAR.REDO' | translate"
            [disabled]="!undoSvc.redoQue.length"
            [matTooltipDisabled]="!undoSvc.redoQue.length"
            matTooltipPosition="below"
            (click)="undoSvc.redo()"></q9-icon-button>
          <q9-primary-button
            *ngIf="
              diagramState === DIAGRAM_VERSION_STATES_ENUM.DRAFT && toolbarState.canEditDiagram
            "
            [disabled]="generationProgressService.dvGenerationInProgress$ | async"
            [q9Track]="toolbarState.editMode ? 'TOOLBAR.TOGGLE_VIEW' : 'TOOLBAR.TOGGLE_EDIT'"
            [matTooltip]="modeButtonTooltip$ | async | translate"
            matTooltipPosition="below"
            (click)="toggleEditMode()">
            {{ (toolbarState.editMode ? 'TOOLBAR.VIEW_MODE' : 'TOOLBAR.EDIT_DIAGRAM') | translate }}
          </q9-primary-button>
        </div>
      </div>
    </q9-toolbar>

    <q9-toolbar *ngIf="diagramState !== DIAGRAM_VERSION_STATES_ENUM.DRAFT">
      <div q9-left-content>
        <q9-primary-button
          [disabled]="generationProgressService.dvGenerationInProgress$ | async"
          [q9Track]="'TOOLBAR.SWITCH_TO_DRAFT'"
          [matTooltip]="'TOOLBAR.SWITCH_TO_DRAFT' | translate"
          matTooltipPosition="below"
          (click)="navigateToDraftVersion(diagramJson.diagramId)">
          {{ 'TOOLBAR.GO_TO_DRAFT' | translate }}
        </q9-primary-button>
      </div>
    </q9-toolbar>

    <q9-toolbar *ngIf="toolbarState.canRequestEditRights">
      <div q9-left-content>
        <q9-primary-button (click)="openRequestRightsDialog()">
          {{ 'SHARE_DIAGRAM.REQUEST_RIGHTS_TITLE' | translate }}
        </q9-primary-button>
      </div>
    </q9-toolbar>

    <app-training-navigation *ngIf="trainingMode$ | async"></app-training-navigation>
    <app-authorisation-navigation *ngIf="authorisationMode$ | async"></app-authorisation-navigation>

    <q9-toolbar class="right">
      <div q9-left-content>
        <q9-icon-button
          [icon]="'more'"
          [matMenuTriggerFor]="actionsMenu"
          [matTooltip]="'TOOLBAR.DIAGRAM_ACTIONS' | translate"
          matTooltipPosition="below"></q9-icon-button>

        <mat-menu #actionsMenu="matMenu" class="q9-menu">
          <button
            mat-menu-item
            class="tool-btn"
            [disabled]="!!(copyDisabledReasonTooltip$ | async)"
            [matTooltip]="copyDisabledReasonTooltip$ | async | translate"
            matTooltipPosition="left"
            [disableRipple]="true"
            (click)="copyMap()">
            {{ 'TOOLBAR.COPY_MAP' | translate }}
          </button>

          <button
            mat-menu-item
            class="tool-btn"
            q9Track="TOOLBAR.PRINT"
            [disableRipple]="true"
            (click)="print()">
            {{ 'POPUPS.PRINT_BTN' | translate }}
          </button>

          <button mat-menu-item class="tool-btn" [disableRipple]="true">
            <app-help-dialog
              [canEdit]="true"
              [strippedMode]="false"
              (click)="$event.stopPropagation()"></app-help-dialog>
          </button>

          <ng-container *ngIf="(diagramJsonSvc.isPro$ | async) || (diagramJsonSvc.isFree$ | async)">
            <ng-container *ngIf="toolbarState.editMode && isVersioningEnabled()">
              <button
                mat-menu-item
                class="tool-btn"
                [disableRipple]="true"
                (click)="changelogSvc.openChangelogPopUp()">
                {{ 'TOOLBAR.TAKE_CHANGELOG' | translate }}
              </button>

              <button
                mat-menu-item
                class="tool-btn"
                q9Track="TOOLBAR.SYNC_URL"
                [disableRipple]="true"
                (click)="openSyncUrlPopup()">
                {{ 'TOOLBAR.SYNC_URL' | translate }}
              </button>
            </ng-container>

            <button
              *ngIf="isVersioningEnabled()"
              mat-menu-item
              class="tool-btn"
              [disableRipple]="true"
              (click)="navigateToMapMgt()">
              {{ 'TOOLBAR.OPEN_MAP_MANAGEMENT' | translate }}
            </button>
          </ng-container>

          <button mat-menu-item class="tool-btn" [disableRipple]="true">
            {{ 'CORE.TOOLBAR.TRAININGS_TOOLTIP' | translate }}
            <q9-trainings
              class="trainings-tool-btn"
              [showTooltip]="false"
              (click)="$event.stopPropagation()"></q9-trainings>
          </button>

          <mat-divider class="menu-divider"></mat-divider>

          <div class="sticky-notes__menu-item">
            <mat-slide-toggle
              color="primary"
              q9Track="TOOLBAR.TOGGLE_STICKY_NOTES"
              [ngClass]="{enabled: stickersSvc.isLayerVisible}"
              [checked]="true"
              (click)="stickersSvc.switchVisible(); $event.stopPropagation()">
              {{ 'TOOLBAR.STICKY_NOTES' | translate }} {{ '(' + stickersSvc.countStickers + ')' }}
            </mat-slide-toggle>
          </div>
        </mat-menu>

        <q9-theme-switcher></q9-theme-switcher>

        <q9-reports (reportAction)="openReportsDialog($event)"></q9-reports>

        <app-diagram-comments></app-diagram-comments>

        <q9-notifications></q9-notifications>

        <q9-primary-button
          *ngIf="!user.userInTeam.team.personal"
          q9Track="TOOLBAR.SHARE_DIAGRAM"
          [matTooltip]="'TOOLBAR.SHARE' | translate"
          matTooltipPosition="below"
          (click)="openShareDiagramPopup()">
          {{ 'SHARE_DIAGRAM.SHARE_DIAGRAM_BTN' | translate }}
        </q9-primary-button>

        <q9-profile-menu></q9-profile-menu>
      </div>
    </q9-toolbar>
  </ng-container>
</div>
